<template>
  <div :class="$style.wrapper">
    <div :class="$style.listWrap">
      <div :class="$style.list">
        <div @click="getNext" v-for="(item, index) in proxyItems" :key="index" :class="[$style.item, item.error && $style.error, item.hero && $style.hero, !item.hero && $style.notHero]">
          <span :class="$style.car" v-if="item.type === 'car'"></span>
          <span v-html="item.text"></span>
          <v-btn v-if="item.type === 'button' && !item.hide" :class="$style.btn" @click="() => clickButton(index)" sm><span v-html="item.button || 'Продолжить'"></span></v-btn>
          <div
            v-if="shouldHaveAvatar(index)"
            :class="$style.char"
            :style="{ backgroundImage: `url(${item.hero ? heroImg : charImg})` }"
          ></div>
          <v-btn v-if="!ready && !item.hideNext && (item.type !== 'button') && index === (proxyItems.length - 1)" :class="$style.btn" sm><span>Далее</span></v-btn>
        </div>
      </div>
    </div>
    <div :class="$style.divider"></div>

    <slot />

    <div :class="$style.char" :style="{ backgroundImage: `url(${charImg})` }"></div>
  </div>
</template>
<script>
const DELAY = process.env.NODE_ENV === 'production' ? 1500 : 300

export default {
  name: 'chat',
  props: {
    char: {
      type: String,
      default: 'localization',
    },
    text: {
      type: Array,
      default: () => [],
    },
    list: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    proxyItems: [],
    newItems: [],
    ready: false,
    heroImg: require('./assets/hero.svg'),
  }),
  mounted() {
    this.getNext()
  },
  methods: {
    shouldHaveAvatar(index) {
      const { proxyItems: chatList } = this

      if (chatList.length === 0) return true

      if (chatList.length - 1 === index) return true

      const current = chatList[index]
      const next = chatList[index + 1]

      return current.hero !== next.hero
    },
    scrollToBottom() {
      const items = Array.from(document.querySelectorAll(`.${this.$style.list} .${this.$style.item}`))

      if (items.length === 0) return

      items[items.length - 1].scrollIntoView()
    },
    clickButton(index) {
      const item = this.proxyItems[index]

      item.hide = true

      if (item.cb) item.cb()
      setTimeout(this.scrollToBottom, DELAY + 200 + 100)
    },
    getNext() {
      const { proxyItems, list, newItems } = this
      if (this.ready) return

      const currentItem = newItems[0]

      if (!currentItem) {
        this.ready = true
        // setTimeout(() => this.$emit('ready'), DELAY + 200)
        this.$emit('ready')
        setTimeout(this.scrollToBottom, DELAY + 200 + 100)
        return
      }
      proxyItems.push(currentItem)

      const oldIds = proxyItems.map(i => i.id)
      this.newItems = list.filter(i => oldIds.indexOf(i.id) === -1)
      if (currentItem.hideNext) {
        this.getNext()
      }
    },
  },
  watch: {
    list: {
      handler() {
        const { proxyItems, list, ready } = this

        const oldIds = proxyItems.map(i => i.id)
        this.newItems = list.filter(i => oldIds.indexOf(i.id) === -1)
        const { newItems } = this

        if (!ready) {
          return
        }

        newItems.forEach((i, index) => {
          const delay = DELAY * index
          setTimeout(() => proxyItems.push(i), delay)
          if (index === newItems.length - 1) {
            // setTimeout(() => this.$emit('ready'), delay + 200)
            setTimeout(this.scrollToBottom, delay + 200 + 100)
          }
        })
      },
      immediate: true,
    },
    proxyItems() {
      setTimeout(this.scrollToBottom, 100)
    },
  },
  computed: {
    charImg() {
      const { char } = this

      if (char === 'perception') return require('./assets/avatars/perception.svg')
      if (char === 'planing') return require('./assets/avatars/planing.svg')
      if (char === 'prediction') return require('./assets/avatars/prediction.svg')

      return require('./assets/avatars/localization.svg')
    },
  },
}
</script>
<style lang="scss" src="./style.scss" module></style>
